import { render } from "./UnPaidBillsStreams.vue?vue&type=template&id=6fe80f49&scoped=true"
import script from "./UnPaidBillsStreams.vue?vue&type=script&lang=js"
export * from "./UnPaidBillsStreams.vue?vue&type=script&lang=js"

import "./UnPaidBillsStreams.vue?vue&type=style&index=0&id=6fe80f49&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe80f49"]])

export default __exports__